export const buildExcelFileBlob = (data: ArrayBuffer) =>
  new Blob([data], { type: 'application/vnd.ms-excel;charset=utf-8' })
